import * as actionTypes from "./actionTypes";

const initialState = {
  pendingRequests: "",
  pendingPayments: "",
  totalPartnersData: "",
  totalCustomersData: "",
  totalCompletedTripsData: "",
  totalCancelledTripsData: "",
  totalBookingsData: null,
  totalRevenueData: "",
  partnerPerformanceData: null,
  regionalInsightsData: null,
  modelPerformanceData: null,
  pendingRequestsLastWeek: "",
  rentalPartnerData: [],
  reTotalBookingsData: [],
  reTotalRevenueData: [],
  reMostBookedRidesData: [],
  reInventoryStatusData: [],
  reInventoryBookingData: [],
  reInventoryBookingLoading: false,
  pendingLoading: false,
  pendingPaymentLoading: false,
  totalPartnerLoading: false,
  totalCustomerLoading: false,
  completedTripsLoading: false,
  cancelledTripsLoading: false,
  totalBookingsLoading: false,
  totalRevenueLoading: false,
  modelPerformanceLoading: false,
  partnerPerformanceLoading: false,
  regionalInsightsLoading: false,
  pendingRequestsLastWeekLoading: false,
  rentalPartnerLoading: false,
  reTotalBookingsLoading: false,
  reTotalRevenueLoading: false,
  reMostBookedRidesLoading: false,
  reInventoryStatusLoading: false,
  totalInquiryTripsData: "",
  inquiryTripsLoading: false,
  reGanttChartData: [],
  reGanttChartLoading: false,
  reTourStatusData: [],
  reTourStatusLoading: false,
  reMapData: [],
  reMapLoading: false,
  motorCycleOutOfBusinessData: [],
  motorCycleOutOfBusinessLoading: false,
  topPartnerPendingLoader: false,
  topPartnerPendingData: [],
  gettingInventoryStatus: false,
  gettingInventoryStatus: null,
  motorCycleOutOfBusinessPartnerData: [],
  motorCycleOutOfBusinessPartnerLoading: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PENDING_REQUEST_DATA:
      return {
        ...state,
        pendingRequests: "",
        pendingLoading: true,
      };
    case actionTypes.GET_PENDING_REQUEST_DATA_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        pendingRequests: action.payload,
        pendingLoading: false,
      };
    case actionTypes.GET_PENDING_REQUEST_DATA_FAILURE:
      return {
        ...state,
        pendingRequests: "",
        pendingLoading: false,
      };

    case actionTypes.GET_PENDING_PAYMENT_DATA:
      return {
        ...state,
        pendingPayments: "",
        pendingPaymentLoading: true,
      };
    case actionTypes.GET_PENDING_PAYMENT_DATA_SUCCESS:
      return {
        ...state,
        pendingPayments: action.payload,
        pendingPaymentLoading: false,
      };
    case actionTypes.GET_PENDING_PAYMENT_DATA_FAILURE:
      return {
        ...state,
        pendingPayments: "",
        pendingPaymentLoading: false,
      };
    case actionTypes.GET_TOTAL_PARTNERS_DATA:
      return {
        ...state,
        totalPartnersData: "",
        totalPartnerLoading: true,
      };
    case actionTypes.GET_TOTAL_PARTNERS_DATA_SUCCESS:
      return {
        ...state,
        totalPartnersData: action.payload,
        totalPartnerLoading: false,
      };
    case actionTypes.GET_TOTAL_PARTNERS_DATA_FAILURE:
      return {
        ...state,
        totalPartnersData: "",
        totalPartnerLoading: false,
      };

    case actionTypes.GET_TOTAL_CUSTOMERS_DATA:
      return {
        ...state,
        totalCustomersData: "",
        totalCustomerLoading: true,
      };
    case actionTypes.GET_TOTAL_CUSTOMERS_DATA_SUCCESS:
      return {
        ...state,
        totalCustomersData: action.payload,
        totalCustomerLoading: false,
      };
    case actionTypes.GET_TOTAL_CUSTOMERS_DATA_FAILURE:
      return {
        ...state,
        totalCustomersData: "",
        totalCustomerLoading: false,
      };

    case actionTypes.GET_COMPLETED_TRIPS_DATA:
      return {
        ...state,
        totalCompletedTripsData: "",
        completedTripsLoading: true,
      };
    case actionTypes.GET_COMPLETED_TRIPS_DATA_SUCCESS:
      return {
        ...state,
        totalCompletedTripsData: action.payload,
        completedTripsLoading: false,
      };
    case actionTypes.GET_COMPLETED_TRIPS_DATA_FAILURE:
      return {
        ...state,
        totalCompletedTripsData: "",
        completedTripsLoading: false,
      };

    case actionTypes.GET_CANCELLED_TRIPS_DATA:
      return {
        ...state,
        totalCancelledTripsData: "",
        cancelledTripsLoading: true,
      };
    case actionTypes.GET_CANCELLED_TRIPS_DATA_SUCCESS:
      return {
        ...state,
        totalCancelledTripsData: action.payload,
        cancelledTripsLoading: false,
      };
    case actionTypes.GET_CANCELLED_TRIPS_DATA_FAILURE:
      return {
        ...state,
        totalCancelledTripsData: "",
        cancelledTripsLoading: false,
      };

    case actionTypes.GET_INQUIRY_TRIPS_DATA:
      return {
        ...state,
        totalInquiryTripsData: "",
        inquiryTripsLoading: true,
      };
    case actionTypes.GET_INQUIRY_TRIPS_DATA_SUCCESS:
      return {
        ...state,
        totalInquiryTripsData: action.payload,
        inquiryTripsLoading: false,
      };
    case actionTypes.GET_INQUIRY_TRIPS_DATA_FAILURE:
      return {
        ...state,
        totalInquiryTripsData: "",
        inquiryTripsLoading: false,
      };

    case actionTypes.GET_TOTAL_BOOKINGS_DATA:
      return {
        ...state,
        totalBookingsData: null,
        totalBookingsLoading: true,
      };
    case actionTypes.GET_TOTAL_BOOKINGS_DATA_SUCCESS:
      return {
        ...state,
        totalBookingsData: action.payload,
        totalBookingsLoading: false,
      };
    case actionTypes.GET_TOTAL_BOOKINGS_DATA_FAILURE:
      return {
        ...state,
        totalBookingsData: null,
        totalBookingsLoading: false,
      };

    case actionTypes.GET_TOTAL_REVENUE_DATA:
      return {
        ...state,
        totalRevenueData: "",
        totalRevenueLoading: true,
      };
    case actionTypes.GET_TOTAL_REVENUE_DATA_SUCCESS:
      return {
        ...state,
        totalRevenueData: action.payload,
        totalRevenueLoading: false,
      };
    case actionTypes.GET_TOTAL_REVENUE_DATA_FAILURE:
      return {
        ...state,
        totalRevenueData: "",
        totalRevenueLoading: false,
      };

    case actionTypes.GET_PARTNER_PERFORMANCE_DATA:
      return {
        ...state,
        partnerPerformanceData: null,
        partnerPerformanceLoading: true,
      };
    case actionTypes.GET_PARTNER_PERFORMANCE_DATA_SUCCESS:
      return {
        ...state,
        partnerPerformanceData: action.payload,
        partnerPerformanceLoading: false,
      };
    case actionTypes.GET_PARTNER_PERFORMANCE_DATA_FAILURE:
      return {
        ...state,
        partnerPerformanceData: null,
        partnerPerformanceLoading: false,
      };

    case actionTypes.GET_REGIONAL_INSIGHTS_DATA:
      return {
        ...state,
        regionalInsightsData: null,
        regionalInsightsLoading: true,
      };
    case actionTypes.GET_REGIONAL_INSIGHTS_DATA_SUCCESS:
      return {
        ...state,
        regionalInsightsData: action.payload,
        regionalInsightsLoading: false,
      };
    case actionTypes.GET_REGIONAL_INSIGHTS_DATA_FAILURE:
      return {
        ...state,
        regionalInsightsData: null,
        regionalInsightsLoading: false,
      };

    case actionTypes.GET_MODEL_PERFORMANCE_DATA:
      return {
        ...state,
        modelPerformanceData: null,
        modelPerformanceLoading: true,
      };
    case actionTypes.GET_MODEL_PERFORMANCE_DATA_SUCCESS:
      return {
        ...state,
        modelPerformanceData: action.payload,
        modelPerformanceLoading: false,
      };
    case actionTypes.GET_MODEL_PERFORMANCE_DATA_FAILURE:
      return {
        ...state,
        modelPerformanceData: null,
        modelPerformanceLoading: false,
      };

    case actionTypes.GET_PENDING_REQUEST_LAST_WEEK_DATA:
      return {
        ...state,
        pendingRequestsLastWeek: "",
        pendingRequestsLastWeekLoading: true,
      };
    case actionTypes.GET_PENDING_REQUEST_LAST_WEEK_DATA_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        pendingRequestsLastWeek: action.payload,
        pendingRequestsLastWeekLoading: false,
      };
    case actionTypes.GET_PENDING_REQUEST_LAST_WEEK_DATA_FAILURE:
      return {
        ...state,
        pendingRequestsLastWeek: "",
        pendingRequestsLastWeekLoading: false,
      };
    case actionTypes.GET_RENTAL_PARTNER_DATA:
      return {
        ...state,
        rentalPartnerData: [],
        rentalPartnerLoading: true,
      };
    case actionTypes.GET_RENTAL_PARTNER_DATA_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        rentalPartnerData: action.payload,
        rentalPartnerLoading: false,
      };
    case actionTypes.GET_RENTAL_PARTNER_DATA_FAILURE:
      return {
        ...state,
        rentalPartnerData: [],
        rentalPartnerLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_BOOKINGS_DATA:
      return {
        ...state,
        reTotalBookingsData: [],
        reTotalBookingsLoading: true,
      };
    case actionTypes.GET_RE_TOTAL_BOOKINGS_DATA_SUCCESS:
      return {
        ...state,
        reTotalBookingsData: action.payload,
        reTotalBookingsLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_BOOKINGS_DATA_FAILURE:
      return {
        ...state,
        reTotalBookingsData: [],
        reTotalBookingsLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_REVENUE_DATA:
      return {
        ...state,
        reTotalRevenueData: [],
        reTotalRevenueLoading: true,
      };
    case actionTypes.GET_RE_TOTAL_REVENUE_DATA_SUCCESS:
      return {
        ...state,
        reTotalRevenueData: action.payload,
        reTotalRevenueLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_REVENUE_DATA_FAILURE:
      return {
        ...state,
        reTotalRevenueData: [],
        reTotalRevenueLoading: false,
      };

    case actionTypes.GET_RE_MOST_BOOKED_RIDES_DATA:
      return {
        ...state,
        reMostBookedRidesData: [],
        reMostBookedRidesLoading: true,
      };
    case actionTypes.GET_RE_MOST_BOOKED_RIDES_DATA_SUCCESS:
      return {
        ...state,
        reMostBookedRidesData: action.payload,
        reMostBookedRidesLoading: false,
      };
    case actionTypes.GET_RE_MOST_BOOKED_RIDES_DATA_FAILURE:
      return {
        ...state,
        reMostBookedToursData: [],
        reMostBookedToursLoading: false,
      };

    case actionTypes.GET_RE_MOST_BOOKED_TOURS_DATA:
      return {
        ...state,
        reMostBookedToursData: [],
        reMostBookedToursLoading: true,
      };
    case actionTypes.GET_RE_MOST_BOOKED_TOURS_DATA_SUCCESS:
      return {
        ...state,
        reMostBookedToursData: action.payload,
        reMostBookedToursLoading: false,
      };
    case actionTypes.GET_RE_MOST_BOOKED_TOURS_DATA_FAILURE:
      return {
        ...state,
        reMostBookedToursData: [],
        reMostBookedToursLoading: false,
      };

    case actionTypes.GET_RE_TOUR_STATUS_DATA:
      return {
        ...state,
        reTourStatusData: [],
        reTourStatusLoading: true,
      };
    case actionTypes.GET_RE_TOUR_STATUS_DATA_SUCCESS:
      return {
        ...state,
        reTourStatusData: action.payload,
        reTourStatusLoading: false,
      };
    case actionTypes.GET_RE_TOUR_STATUS_DATA_FAILURE:
      return {
        ...state,
        reTourStatusData: [],
        reTourStatusLoading: false,
      };

    case actionTypes.GET_RE_MAP_DATA:
      return {
        ...state,
        reMapData: [],
        reMapLoading: true,
      };
    case actionTypes.GET_RE_MAP_DATA_SUCCESS:
      return {
        ...state,
        reMapData: action.payload,
        reMapLoading: false,
      };
    case actionTypes.GET_RE_MAP_DATA_FAILURE:
      return {
        ...state,
        reMapData: [],
        reMapLoading: false,
      };

    case actionTypes.GET_RE_INVENTORY_STATUS_DATA:
      return {
        ...state,
        reInventoryStatusData: [],
        reInventoryStatusLoading: true,
      };
    case actionTypes.GET_RE_INVENTORY_STATUS_DATA_SUCCESS:
      return {
        ...state,
        reInventoryStatusData: action.payload,
        reInventoryStatusLoading: false,
      };
    case actionTypes.GET_RE_INVENTORY_STATUS_DATA_FAILURE:
      return {
        ...state,
        reInventoryStatusData: [],
        reInventoryStatusLoading: false,
      };
    case actionTypes.GET_RE_INVENTORY_BOOKING_CALENDAR_DATA:
      return {
        ...state,
        reInventoryBookingData: [],
        reInventoryBookingLoading: true,
      };
    case actionTypes.GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_SUCCESS:
      return {
        ...state,
        reInventoryBookingData: action.payload,
        reInventoryBookingLoading: false,
      };
    case actionTypes.GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_FAILURE:
      return {
        ...state,
        reInventoryBookingData: [],
        reInventoryBookingLoading: false,
      };
    case actionTypes.GET_RE_GANTT_CHART_DATA:
      return {
        ...state,
        reGanttChartData: [],
        reGanttChartLoading: true,
      };
    case actionTypes.GET_RE_GANTT_CHART_DATA_SUCCESS:
      return {
        ...state,
        reGanttChartData: action.payload,
        reGanttChartLoading: false,
      };
    case actionTypes.GET_RE_GANTT_CHART_DATA_FAILURE:
      return {
        ...state,
        reGanttChartData: [],
        reGanttChartLoading: false,
      };
    case actionTypes.CLEAR_PREVIOUS_REDUCER:
      return {
        reGanttChartData: [],
      };
    case actionTypes.GET_MOTORCYCLE_OUT_OF_BUSINESS_DATA:
      return {
        ...state,
        motorCycleOutOfBusinessLoading: true,
      };
    case actionTypes.GET_MOTORCYCLE_OUT_OF_BUSINESS_SUCCESS:
      return {
        ...state,
        motorCycleOutOfBusinessLoading: false,
        motorCycleOutOfBusinessData: action.payload,
      };
    case actionTypes.GET_CANCELLED_TRIPS_DATA_FAILURE:
      return {
        ...state,
        motorCycleOutOfBusinessLoading: false,
      };
    case actionTypes.GET_TOP_PARTNERS_WITH_PENDING_LEADS:
      return {
        ...state,
        topPartnerPendingLoader: true,
      };
    case actionTypes.GET_TOP_PARTNERS_WITH_PENDING_LEADS_SUCCESS:
      return {
        ...state,
        topPartnerPendingLoader: false,
        topPartnerPendingData: action.payload,
      };
    case actionTypes.GET_TOP_PARTNERS_WITH_PENDING_LEADS_FAILURE:
      return {
        ...state,
        topPartnerPendingLoader: false,
      };

    case actionTypes.GET_INVENTORY_STATUS_PENDING:
      return {
        ...state,
        gettingInventoryStatus: true,
      };
    case actionTypes.GET_INVENTORY_STATUS_SUCCESS:
      return {
        ...state,
        gettingInventoryStatus: false,
        invetoryStatusData: action.payload,
      };
    case actionTypes.GET_INVENTORY_STATUS_FAILURE:
      return {
        ...state,
        gettingInventoryStatus: false,
      };

    case actionTypes.GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_PENDING:
      return {
        ...state,
        motorCycleOutOfBusinessPartnerLoading: true,
      };
    case actionTypes.GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_SUCCESS:
      return {
        ...state,
        motorCycleOutOfBusinessPartnerLoading: false,
        motorCycleOutOfBusinessPartnerData: action.payload,
      };
    case actionTypes.GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_FAILURE:
      return {
        ...state,
        motorCycleOutOfBusinessPartnerLoading: false,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
